var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfinityIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50.55 22.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#36b22d;}.cls-2{fill:none;}.cls-3{fill:#00a5e3;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "iconfinder_icon-ios7-infinite_211760"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m42.54,16.12c.83-.54,1.53-1.23,2.02-2.06.47-.84.73-1.8.71-2.76,0-1.96-1.12-3.76-2.83-4.77.31-.29.64-.56.99-.83.92.62,1.75,1.48,2.28,2.49.56,1,.8,2.16.8,3.3-.04,1.14-.33,2.29-.93,3.27-.58.99-1.44,1.8-2.37,2.4l-.67-1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m40.18,5.59c-1.93-.45-4.04-.08-5.69,1.02-.8.51-1.58,1.32-2.38,2.02l-2.39,2.15-.83-.92,2.32-2.09,1.16-1.05c.37-.34.79-.71,1.26-1.04,1.84-1.28,4.19-1.78,6.4-1.4.07.44.11.87.14,1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m39.82,5.51c1.04.19,2.03.6,2.91,1.2l.7-1.01c-.35-.24-.77-.37-1.21-.35-.21,0-.44.03-.65.05-.6-.04-1.2.03-1.75.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m40.04,4.3c.41.09.8.28,1.11.6.16.15.3.32.43.49-.21.02-.41.05-.62.1-.41.07-.78.1-1.13.03l.21-1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m38.57,3.55v.62c.44.01.88.04,1.31.11l.1-.61c-.47-.08-.94-.11-1.41-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m38.56,5.4v.62c.34,0,.69.03,1.03.09l.1-.61c-.37-.06-.75-.08-1.13-.09Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "20.22 3.44 29.81 12.01 28.72 12.69 19.43 4.38 20.22 3.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m31.79,13.79l1.2,1.07c.4.36.8.73,1.18,1.01.79.59,1.72,1,2.68,1.23,1.93.46,4.04.1,5.69-.99l.67,1.04c-1.88,1.23-4.24,1.67-6.43,1.2-1.1-.23-2.15-.67-3.07-1.3-.96-.66-1.63-1.38-2.43-2.07l.52-1.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m32.08,14.06l-2.55-2.29-.81.92c.29.26.65.44,1.07.54l.62.14,1.68.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m31.27,14.98c-.29-.26-.51-.6-.66-1l-.22-.6.62.14c.42.1.78.28,1.07.54l-.81.92Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "31.89 16.36 32.29 15.9 31.38 15.08 30.97 15.54 31.89 16.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "33.1 14.97 33.51 14.51 32.6 13.69 32.19 14.16 33.1 14.97"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m.44,14.36c-.67-2.18-.57-4.58.24-6.7.82-2.13,2.43-3.93,4.32-5.11.11.42.24.83.37,1.23-1.65,1.11-2.93,2.66-3.6,4.49-.67,1.83-.72,3.87-.16,5.73l-1.18.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m7.5,1.28c4.23-1.61,9.26-.77,12.73,2.16l-.79.94c-3.02-2.57-7.41-3.35-11.15-2.07-.25-.35-.51-.71-.79-1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m7.89,1.15c-1.13.39-2.23.91-3.21,1.6l.7,1.01c.32-.19.55-.51.78-.85l.35-.53c.42-.44.88-.86,1.39-1.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m8.28,2.32c-.36.1-.72.17-1.15.11-.21-.03-.42-.04-.63-.04.12-.18.24-.36.38-.52.28-.33.61-.61,1.01-.72l.39,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m9.67,2.58l-.13-.6c-.38.07-.76.17-1.12.3l.19.59c.35-.12.7-.22,1.06-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m9.28.77l-.13-.6c-.44.09-.88.2-1.3.35l.19.59c.41-.14.82-.25,1.24-.33Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m24.51,15.44l-2.39,2.15c-.81.71-1.54,1.44-2.47,2.13-1.81,1.33-3.97,2.18-6.21,2.43.08-.43.15-.85.21-1.27.98-.14,1.94-.39,2.85-.78.92-.37,1.77-.88,2.56-1.47l.58-.45.58-.52,1.16-1.04,2.32-2.08.82.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m10.65,22.16c-2.24-.23-4.41-1.07-6.24-2.39-.44-.35-.9-.68-1.28-1.1-.41-.4-.81-.8-1.14-1.27-.67-.92-1.2-1.95-1.54-3.04l1.18-.36c1.13,3.78,4.91,6.36,8.78,6.89.07.42.15.85.24,1.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m10.24,22.11c1.19.17,2.4.17,3.59,0l-.17-1.22c-.37.05-.72.2-1.08.41l-.54.33c-.57.18-1.17.38-1.79.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m10.4,20.89c.37.06.72.2,1.08.41l.55.33-.57.28c-.4.2-.82.26-1.22.2l.17-1.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m9.28,20.04l-.15.6c.38.07.75.19,1.14.23l.09-.61c-.37-.03-.72-.15-1.08-.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m8.82,21.83l-.15.6c.44.09.87.22,1.32.26l.09-.61c-.43-.04-.84-.17-1.26-.25Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "iconfinder_icon-ios7-infinite_211760-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m8.02,6.57c-.84.54-1.54,1.22-2.03,2.06-.47.83-.73,1.8-.72,2.76-.01,1.96,1.11,3.76,2.81,4.78-.31.29-.64.56-.99.83-.92-.62-1.74-1.49-2.27-2.5-.55-1.01-.8-2.16-.79-3.3.04-1.14.34-2.29.94-3.26.58-.99,1.45-1.79,2.37-2.39l.67,1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m10.35,17.1c1.93.46,4.04.09,5.69-1,.8-.51,1.58-1.32,2.38-2.02l2.39-2.15.83.92-2.32,2.09-1.16,1.04c-.37.34-.8.71-1.26,1.03-1.85,1.27-4.2,1.78-6.4,1.38-.07-.43-.11-.87-.14-1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m10.71,17.18c-1.04-.19-2.03-.6-2.9-1.2l-.7,1.01c.35.24.77.37,1.21.35.21,0,.44-.02.65-.04.6.04,1.2-.02,1.75-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m10.49,18.39c-.41-.09-.8-.28-1.1-.6-.16-.15-.3-.32-.43-.49.21-.02.41-.05.62-.09.41-.07.78-.1,1.13-.03l-.22,1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m11.95,19.14v-.62c-.44,0-.87-.04-1.31-.11l-.1.61c.47.08.94.11,1.41.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m11.97,17.29v-.62c-.34,0-.69-.03-1.03-.09l-.1.61c.37.06.75.09,1.13.1Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "30.34 19.27 20.75 10.69 21.84 10.02 31.13 18.32 30.34 19.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m18.77,8.91l-1.2-1.07c-.4-.36-.8-.73-1.18-1.01-.79-.59-1.71-1.01-2.68-1.23-1.93-.46-4.04-.11-5.69.97l-.67-1.04c1.88-1.22,4.25-1.66,6.44-1.18,1.1.23,2.15.68,3.07,1.3.96.67,1.63,1.38,2.43,2.07l-.52,1.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m18.48,8.65l2.55,2.29.81-.92c-.29-.26-.65-.44-1.07-.54l-.62-.14-1.68-.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m19.29,7.73c.29.26.51.6.66,1l.22.6-.62-.14c-.42-.1-.78-.28-1.07-.54l.81-.92Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "18.67 6.35 18.27 6.81 19.18 7.63 19.59 7.16 18.67 6.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "17.46 7.73 17.05 8.2 17.96 9.01 18.37 8.55 17.46 7.73"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m50.1,8.32c.67,2.18.58,4.58-.23,6.71-.82,2.13-2.42,3.94-4.31,5.12-.11-.42-.24-.82-.37-1.23.8-.58,1.57-1.2,2.17-1.97.6-.76,1.09-1.62,1.43-2.53.67-1.83.71-3.87.15-5.73l1.18-.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m43.06,21.41c-4.23,1.61-9.26.78-12.73-2.14l.79-.95c3.02,2.56,7.41,3.35,11.15,2.05.25.35.52.71.79,1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m42.67,21.54c1.13-.4,2.23-.91,3.21-1.61l-.7-1.01c-.32.19-.55.51-.78.85l-.35.53c-.42.44-.88.86-1.39,1.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m42.28,20.38c.36-.1.72-.17,1.15-.12.21.03.42.04.63.04-.12.18-.24.36-.38.52-.28.33-.61.62-1,.72l-.39-1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m40.89,20.12l.13.6c.38-.07.76-.17,1.12-.3l-.19-.59c-.35.12-.7.22-1.06.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m41.28,21.92l.13.6c.44-.09.88-.2,1.3-.35l-.19-.59c-.41.14-.82.25-1.24.33Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m26.02,7.27l2.39-2.15c.81-.71,1.54-1.45,2.47-2.14,1.81-1.33,3.97-2.19,6.21-2.43-.08.43-.15.85-.21,1.27-.98.14-1.94.39-2.85.79-.92.37-1.77.88-2.56,1.47l-.58.46-.58.52-1.16,1.04-2.31,2.09-.83-.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m39.88.53c2.24.23,4.41,1.07,6.24,2.39.44.35.9.67,1.29,1.1.41.4.81.8,1.14,1.27.68.92,1.21,1.94,1.55,3.03l-1.18.37c-1.14-3.77-4.93-6.35-8.8-6.88-.07-.42-.15-.85-.24-1.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m40.29.59c-1.19-.17-2.4-.17-3.59.01l.17,1.22c.37-.05.72-.21,1.08-.41l.54-.33c.57-.18,1.17-.38,1.79-.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m40.12,1.81c-.37-.06-.72-.2-1.08-.41l-.55-.33.57-.28c.4-.2.82-.27,1.22-.2l-.17,1.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m41.25,2.65l.15-.6c-.38-.07-.75-.19-1.14-.23l-.09.61c.37.03.72.15,1.08.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m41.7.86l.15-.6c-.44-.09-.87-.22-1.32-.26l-.09.61c.43.04.84.17,1.26.25Z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfinityIcon);
export default __webpack_public_path__ + "static/media/infinity-icon.5fda12f9d8e07d7f53964313651583d7.svg";
export { ForwardRef as ReactComponent };